import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FivaLayout from "../Layout/FivaLayout";
import HeadComponent from "../components/HeadComponent/HeadComponent";
import ServiceTerms from "../components/ServiceTerms/ServiceTerms";
var TermsOfService = function() {
    var headerProps = {
        title: "T\xe9rminos de servicio",
        keywords: 'T\xe9rminos de servicio, Plataforma web "FIVA", FIVA E&S SOLUTIONS, SL, Datos personales,    Propiedad intelectual, Privacidad, Protecci\xf3n de datos, Responsabilidades del usuario,    Proceso de contrataci\xf3n, Cancelaci\xf3n, Modificaciones de los t\xe9rminos, Ley aplicable, Jurisdicci\xf3n,    Disposiciones generales, Independencia, Cesi\xf3n, Acuerdo completo, Renuncia, Divisibilidad, Comunicaciones',
        content: "T\xe9rminos de Servicio de FIVA, informaci\xf3n sobre el uso de la plataforma."
    };
    return /*#__PURE__*/ _jsxs(FivaLayout, {
        blue: false,
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(ServiceTerms, {})
        ]
    });
};
export default TermsOfService;
